export const getCsrf = () => {
  if (
    window !== undefined &&
    window.CSRF !== undefined &&
    !window.CSRF.token.startsWith("$") &&
    !window.CSRF.headerName.startsWith("$") &&
    window.CSRF.token !== "" &&
    window.CSRF.headerName !== ""
  ) {
    return { token: window.CSRF.token, headerName: window.CSRF.headerName };
  } else {
    return { token: "", headerName: "X-CSRF-TOKEN" };
  }
};
